/**
 * Get APP's API Key
 */

import { gql } from '@apollo/client'

export const GET_APP_API_KEY = gql`
  query AppAPIKey($appType: String!) {
    appAPIKey(input: { appType: $appType }) {
      appType
      apiKey
      enabled
    }
  }
`

/**
 * Get all app download configurations for the workspace
 */
export const APP_DOWNLOAD_CONFIGURATIONS = gql`
  query AppDownloadConfigurations {
    appDownloadConfigurations {
      actions
      description
      name
      ruleID
      status
      trigger
    }
  }
`
